const gearNftContractAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'string',
        name: 'saleId',
        type: 'string',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'buyer',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'currencyTokenContract',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'price',
        type: 'uint256',
      },
    ],
    name: 'NFTExchanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'string',
        name: 'code',
        type: 'string',
      },
    ],
    name: 'ReferralAdded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'string',
        name: 'saleId',
        type: 'string',
      },
    ],
    name: 'SaleScheduleAdded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'string',
        name: 'supplyId',
        type: 'string',
      },
    ],
    name: 'SupplyAdded',
    type: 'event',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'referralCode',
        type: 'string',
      },
    ],
    name: 'getReferralInfo',
    outputs: [
      {
        components: [
          {
            internalType: 'string',
            name: 'code',
            type: 'string',
          },
          {
            internalType: 'uint256',
            name: 'gear1Count',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'gear10Count',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'gear100Count',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'tokenAmount',
            type: 'uint256',
          },
        ],
        internalType: 'struct GearNFTSale.Referral',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'supplyId',
        type: 'string',
      },
    ],
    name: 'addSupply',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'supplyId',
        type: 'string',
      },
    ],
    name: 'getSupply',
    outputs: [
      {
        components: [
          {
            internalType: 'string',
            name: 'supplyId',
            type: 'string',
          },
          {
            internalType: 'uint256',
            name: 'supplyAmount',
            type: 'uint256',
          },
        ],
        internalType: 'struct GearNFTSale.Supply',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'saleId',
        type: 'string',
      },
      {
        internalType: 'address',
        name: 'nftHolder',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'nftContract',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'currencyTokenContract',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'startDate',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'endDate',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'price',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'totalAmount',
        type: 'uint256',
      },
      {
        internalType: 'string',
        name: 'supplyId',
        type: 'string',
      },
    ],
    name: 'addSaleSchedule',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'saleId',
        type: 'string',
      },
    ],
    name: 'getSaleScheduleConsts',
    outputs: [
      {
        components: [
          {
            internalType: 'string',
            name: 'saleId',
            type: 'string',
          },
          {
            internalType: 'address',
            name: 'nftHolder',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'nftContract',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'currencyTokenContract',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'startDate',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'endDate',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'price',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'totalAmount',
            type: 'uint256',
          },
        ],
        internalType: 'struct GearNFTSale.SaleScheduleConstants',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'saleId',
        type: 'string',
      },
    ],
    name: 'getSaleScheduleInfo',
    outputs: [
      {
        components: [
          {
            internalType: 'string',
            name: 'saleId',
            type: 'string',
          },
          {
            internalType: 'uint256',
            name: 'startDate',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'endDate',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'price',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'totalAmount',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'supplyAmount',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'exchangedCount',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'collectedAmount',
            type: 'uint256',
          },
          {
            internalType: 'string',
            name: 'supplyId',
            type: 'string',
          },
          {
            internalType: 'bool',
            name: 'isValid',
            type: 'bool',
          },
        ],
        internalType: 'struct GearNFTSale.SaleScheduleInfo',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'saleId',
        type: 'string',
      },
    ],
    name: 'delSaleSchedule',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'saleId',
        type: 'string',
      },
    ],
    name: 'mintable',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'saleId',
        type: 'string',
      },
      {
        internalType: 'string',
        name: 'referralCode',
        type: 'string',
      },
    ],
    name: 'exchange',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
    payable: true,
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'saleId',
        type: 'string',
      },
    ],
    name: 'getNFTGrade',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'string[]',
        name: 'saleIds',
        type: 'string[]',
      },
      {
        internalType: 'uint256[]',
        name: 'amounts',
        type: 'uint256[]',
      },
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address',
      },
    ],
    name: 'transferNFTs',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'saleId',
        type: 'string',
      },
    ],
    name: 'collect',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'onERC721Received',
    outputs: [
      {
        internalType: 'bytes4',
        name: '',
        type: 'bytes4',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
]; // NFT 컨트랙트 ABI

export default gearNftContractAbi;
